/* AxisLeft.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { element } from '../../../core/elements';
import { defaultTextHTMLProps } from '../constants/default_text';
import Orientation from '../constants/orientation';
import getAxisDataType from '../utils/getAxisDataType';
import getTickFormatter from '../utils/getTickFormatter';
import { AxisLine, axisLineStroke } from './AxisLine';
import { Tick } from './Tick';
import { TickText } from './TickText';
import { useAxisTicks } from './useAxisTicks';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _9 = "._u5f31crf{padding-right:9pt}";
const _8 = "._2z05hkll{grid-template-rows:1fr}";
const _7 = "._yv0ehkll{grid-template-columns:1fr}";
const _6 = "._wij21bp4{grid-auto-flow:column}";
const _5 = "._1bsb1ris{width:-moz-max-content;width:max-content}";
const _4 = "._1tke1osq{min-height:100%}";
const _3 = "._yv0ey09t{grid-template-columns:min-content auto}";
const _2 = "._1e0c11p5{display:grid}";
const _ = "._nd5l1jbf{grid-area:axis-left}";
export const leftTickLabelProps = {
  color: "var(--ds-text-subtlest, grey)",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  fontSize: 12
};
const tickLength = 8;
const orientation = Orientation.left;
export const AxisLeftTick = element(Tick);
export const AxisLeftLine = element(_ref => {
  let {
    height,
    hide
  } = _ref;
  return /*#__PURE__*/_jsx(AxisLine, {
    hide: hide,
    style: {
      borderLeft: `2px solid ${axisLineStroke}`,
      height: `${height}px`,
      position: 'absolute',
      transform: 'translateX(-1px)'
    }
  });
});
export const AxisLeftText = element(_ref2 => {
  let {
    width,
    formatter,
    truncate,
    singleline,
    children
  } = _ref2;
  return /*#__PURE__*/_jsx(TickText, {
    style: {
      maxWidth: width
    },
    formatter: formatter,
    truncate: truncate,
    singleline: singleline,
    children: children
  });
});
function AxisLeft(_ref3) {
  let {
    scale,
    numTicks,
    tickValues,
    rangePadding,
    hideZero,
    // TODO: Should label become it's own element?
    label
  } = _ref3;
  const {
    ticks
  } = useAxisTicks({
    scale,
    numTicks,
    tickValues,
    orientation,
    rangePadding,
    hideZero,
    tickLength
  });
  const TicksComponent = ticks.map(_ref4 => {
    let {
      value,
      index,
      from,
      to
    } = _ref4;
    const formatter = getTickFormatter(scale);
    return /*#__PURE__*/_jsx("div", {
      style: {
        // Ugh I hate you magic number
        top: `calc(${to.y}px - .6em)`,
        minWidth: 0,
        gridColumn: 1,
        gridRow: 1,
        position: 'relative',
        textAlign: 'right',
        ...leftTickLabelProps
      },
      children: /*#__PURE__*/_jsx(AxisLeftText, {
        formatter: formatter,
        width: 250,
        truncate: getAxisDataType(scale) === 'string',
        children: value
      })
    }, `axis-left-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        gridArea: 'plot',
        display: 'flex'
      },
      children: /*#__PURE__*/_jsx(AxisLeftLine, {
        height: scale.range()[0]
      })
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4]
      }), /*#__PURE__*/_jsxs("div", {
        "data-axis-type": "axis-left",
        className: ax(["_nd5l1jbf _1e0c11p5 _yv0ey09t _1tke1osq"]),
        children: [label && /*#__PURE__*/_jsx("div", {
          style: {
            overflow: 'hidden',
            height: '100%',
            width: 'max-content',
            textOverflow: 'ellipsis',
            alignSelf: 'center',
            writingMode: 'vertical-rl',
            transform: 'rotate(-180deg)',
            paddingLeft: '8px',
            whiteSpace: 'nowrap',
            ...defaultTextHTMLProps
          },
          children: label
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_2, _5, _6, _7, _8, _9]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1e0c11p5 _1bsb1ris _wij21bp4 _yv0ehkll _2z05hkll _u5f31crf"]),
            children: TicksComponent
          })]
        })]
      })]
    })]
  });
}
const _AxisLeft = element(AxisLeft);
export { _AxisLeft as AxisLeft };